"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class HttpManagementPayload {
    constructor(id, statusQueryGetUri, sendEventPostUri, terminatePostUri, rewindPostUri, purgeHistoryDeleteUri) {
        this.id = id;
        this.statusQueryGetUri = statusQueryGetUri;
        this.sendEventPostUri = sendEventPostUri;
        this.terminatePostUri = terminatePostUri;
        this.rewindPostUri = rewindPostUri;
        this.purgeHistoryDeleteUri = purgeHistoryDeleteUri;
    }
}
exports.HttpManagementPayload = HttpManagementPayload;
//# sourceMappingURL=httpmanagementpayload.js.map